import { css } from 'styled-components';
/**
 * VisuallyHidden components are used to hide text that provides context to
 * users of screenreaders and other audio interfaces.
 *
 * This is necessary because other techniques to remove items from the layout
 * of a page (for example, `display: none`) also remove the content from
 * the accessibility tree.
 */

var visuallyHiddenCSS = css(["border:0 !important;clip:rect(0 0 0 0);-webkit-clip-path:inset(0 0 100% 100%);clip-path:inset(0 0 100% 100%);height:1px !important;margin:-1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;"]);
export default visuallyHiddenCSS;